export const signupForm = {
  first_name: "firstname",
  last_name: "lastname",
  email: "email",
  mobile: "mobile",
  password: "password",
  confirm_password: "confirm_password",
  company_name: "company_name",
  address: "address",
  pincode: "pincode",
  country: "country",
  state: "state",
  city: "city",
  role: "role",
  street: "street",
  otp: "otp",
  confirmation_text: "confirmation_text",
};

export const defaultSignUpFormValues = {
  first_name: "",
  last_name: "",
  email: "",
  mobile: "",
  password: "",
  confirm_password: "",
  company_name: "",
  address: "",
  pincode: "",
  country: "",
  state: "",
  city: "",
  role: "",
  street: "",
  otp: "",
};
